<template>
    <div class="tag-group" :style="{width: width + 'px;'}">
       <slot></slot>
    </div>
</template>

<script>
export default {
  name: "ComTag",
  provide(){
    return {
      
    }
  },
  props:{
    width: Number
  }
}
</script>

<style lang="scss">
.tag-group{
  .tag-item{
    min-width: 80px;
    height: 40px;
    line-height: 39px;
    background: #F5F5F7;
    border-radius: 8px;
    font-size: 14px;
    color: #222;
    text-align: center;
    display: inline-block;
    margin:0 10px 10px 0;
    padding: 0 12px;
    box-sizing: border-box;
    
    cursor: pointer;
    &-active{
      background: #67B4C4;
      color: #fff;
    }
  }
}
.tag-default-group{
  .tag-item{
    background: #fff;
    border: 1px solid #D8E0F0;
    &-active{
      background: #67B4C4;
      border: 1px solid #67B4C4;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Tag.vue